<template>
  <div class="saas-section home-v2-community saas-section--gray">
    <div class="home-v2-community__image">
      <img src="@saas/assets/images/community-intro.png" />
    </div>
    <div class="saas-section__title">
      <h2 class="saas-section__title-heading">
        {{ block.title }}
      </h2>
      <div class="saas-section__description">
        {{ block.text }}
      </div>
    </div>
    <div
      v-for="(group, index) in groupedMessages"
      :key="index"
      class="home-v2-community__messages-wrapper"
    >
      <div class="home-v2-community__messages">
        <div class="home-v2-community__message-wrapper">
          <div class="home-v2-community__message-placeholder"></div>
        </div>
        <div class="home-v2-community__message-wrapper">
          <div class="home-v2-community__message-placeholder"></div>
        </div>
        <div
          v-for="(message, messageIndex) in group"
          :key="messageIndex"
          class="home-v2-community__message-wrapper"
        >
          <div class="home-v2-community__message-border">
            <div class="home-v2-community__message">
              <div class="home-v2-community__message-text">
                {{ message.text }}
              </div>
              <div class="home-v2-community__message-author-name">
                {{ message.author_name }}
              </div>
              <div class="home-v2-community__message-author-role">
                {{ message.author_role }}
              </div>
            </div>
          </div>
        </div>
        <div class="home-v2-community__message-wrapper">
          <div class="home-v2-community__message-placeholder"></div>
        </div>
        <div class="home-v2-community__message-wrapper">
          <div class="home-v2-community__message-placeholder"></div>
        </div>
      </div>
    </div>
    <div
      class="home-v2-community__messages-wrapper home-v2-community__messages-wrapper--forced-placeholders"
    >
      <div class="home-v2-community__messages">
        <div class="home-v2-community__message-wrapper">
          <div class="home-v2-community__message-placeholder"></div>
        </div>
        <div class="home-v2-community__message-wrapper">
          <div class="home-v2-community__message-placeholder"></div>
        </div>
        <div class="home-v2-community__message-wrapper">
          <div class="home-v2-community__message-placeholder"></div>
        </div>
        <div class="home-v2-community__message-wrapper">
          <div class="home-v2-community__message-placeholder"></div>
        </div>
        <div class="home-v2-community__message-wrapper">
          <div class="home-v2-community__message-placeholder"></div>
        </div>
        <div class="home-v2-community__message-wrapper">
          <div class="home-v2-community__message-placeholder"></div>
        </div>
        <div class="home-v2-community__message-wrapper">
          <div class="home-v2-community__message-placeholder"></div>
        </div>
      </div>
    </div>
    <div class="saas-section__actions margin-bottom-0">
      <CmsLink
        v-for="button in block.buttons"
        :key="button.id"
        :url-or-path="button.url_or_path"
        :class="`button button--${button.type} button--large`"
      >
        {{ button.text }}
      </CmsLink>
    </div>
  </div>
</template>

<script>
import CmsLink from '@saas/components/cms/CmsLink'

export default {
  name: 'PageBlockCommunity',
  components: { CmsLink },
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
  computed: {
    groupedMessages() {
      const messages = this.block.messages
      const chunkSize = 3
      const grouped = []

      for (let i = 0; i < messages.length; i += chunkSize) {
        grouped.push(messages.slice(i, i + chunkSize))
      }

      return grouped
    },
  },
}
</script>
